<template>
    <transition name="move">
        <div v-show="show" :class="toastClass">
          <i :class="iconClass">
            <svg viewBox="64 64 896 896" class="" data-icon="check-circle" width="1em" height="1em" fill="currentColor" aria-hidden="true">
              <path :d="icon[type]"></path>
            </svg>
          </i>
          <span class="wps-toast-text">{{ message }}</span>
        </div>    
    </transition>
</template>

<script>
export default {
    data: () => ({
        show: false,
        message: '123456',
        duration: 3000,
        type: 'info', // info | success | warning | error,
        icon: {
          success: 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z',
          error: 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 0 1-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z',
          warning: 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z',
          info: 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'
        }
    }),

    computed: {
        toastClass() {
            return 'wps-toast wps-toast-' + this.type;
        },
        iconClass() {
            return 'wps-toast-icon wps-toast-icon-' + this.type;
        },
    },

    methods: {
        showToast(message, type = 'primary') {
            if (this.show) return;
            this.message = message;
            this.type = type;
            this.show = true;
            setTimeout(() => {
                this.show = false;
            }, this.duration);
        }
    }
}
</script>

<style scoped>
.wps-toast {
    background-color: rgba(0, 0, 0, .7);
    padding: 0 15px;
    height: 30px;
    line-height: 30px;
    display: inline-block;
    position: fixed;
    top: 145px;
    left: 50%;
    transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
    color: #fff;
    border-radius: 4px;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 12px;
    z-index: 999;
    border-width: 1px;
    border-style: solid;
}

.wps-toast.wps-toast-success {
    background-color: #DEF2DA;
    border-color: #71C76F;
    color: #333;
}

.wps-toast.wps-toast-warning {
    background-color: #FFF7CF;
    border-color: #B58D17;
    color: #333;
}

.wps-toast.wps-toast-error {
    background-color: #FFF2F0;
    border-color: #EB5E5E;
    color: #333;
}

.wps-toast.wps-toast-info {
    background-color: #E0F0FF;
    border-color: #5087E5;
    color: #333;
}

.move-enter-active, .move-leave-active {
  transition: all .2s;
  -webkit-transition: all .2s;
}
.move-enter, .move-leave-to {
  opacity: 0;
  margin-top: 20px;
}

.wps-toast-icon {
  display: inline-block;
  height: 14px;
  width: 14px;
  line-height: 14px;
  font-size: 14px;
  vertical-align: middle;
  margin-right: 4px;
}

.wps-toast-icon.wps-toast-icon-success {
  color: #52C41A;
}

.wps-toast-icon.wps-toast-icon-error {
  color: #F5222D;
}

.wps-toast-icon.wps-toast-icon-warning {
  color: #FAAD14;
}

.wps-toast-icon.wps-toast-icon-info {
  color: #1890FF;
}

.wps-toast-text {
  display: inline-block;
  vertical-align: middle;
}
</style>




// WEBPACK FOOTER //
// Toast.vue?2ee5b61c